document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#MainNav');
  if (menuButton && nav) menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('open');
  });

  const directory = document.querySelector('[data-track-directory]');
  if (directory) {
    const search = directory.querySelector('[data-track-search]');
    const state = directory.querySelector('[data-track-state]');
    const region = directory.querySelector('[data-track-region]');
    const status = directory.querySelector('[data-track-status]');
    const cards = [...directory.querySelectorAll('[data-track-card]')];
    const count = directory.querySelector('[data-track-count]');
    const empty = directory.querySelector('[data-track-empty]');
    const applyFilters = () => {
      const term = search.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach(card => {
        const show = (!term || card.dataset.search.includes(term)) &&
          (state.value === 'all' || card.dataset.state === state.value) &&
          (region.value === 'all' || card.dataset.region === region.value) &&
          (status.value === 'all' || card.dataset.status === status.value);
        card.hidden = !show;
        if (show) visible += 1;
      });
      count.textContent = visible;
      empty.hidden = visible !== 0;
    };
    [search, state, region, status].forEach(control => control.addEventListener(control.tagName === 'INPUT' ? 'input' : 'change', applyFilters));
    directory.querySelector('[data-track-reset]').addEventListener('click', () => {
      search.value = ''; state.value = 'all'; region.value = 'all'; status.value = 'all'; applyFilters();
    });
    const params = new URLSearchParams(window.location.search);
    if (params.get('state')) { state.value = params.get('state').toUpperCase(); applyFilters(); }
  }

  const forumState = document.querySelector('[data-forum-state]');
  const forumGo = document.querySelector('[data-forum-go]');
  if (forumState && forumGo) forumState.addEventListener('change', () => {
    const base = forumState.dataset.forumBase.replace(/\/$/, '');
    const selected = forumState.value;
    forumGo.classList.toggle('disabled', !selected);
    if (selected && base) forumGo.href = `${base}/tag/${selected}`;
  });
});
